import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Icon from "@mdi/react";
import { mdiMenu, mdiClose } from "@mdi/js";
import logoVinefin from "./img/logoVinefin.png";
import NavbarLink from "./NavbarLink";
import LanguageDropdown from "./LanguageDropdown";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md shadow-md py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-3 items-center h-16">
          {/* Logo Section */}
          <div className="flex justify-start pointer-events-none">
            <Link to="/" className="pointer-events-auto">
              <img
                className="h-10 md:h-12 w-auto"
                src={logoVinefin}
                alt="vinefin.cz"
              />
            </Link>
          </div>

          {/* Desktop Links - Centered */}
          <div className="hidden lg:flex justify-center space-x-6 xl:space-x-8 pointer-events-none">
            <NavbarLink to="/" className="pointer-events-auto">{t("navbar.aboutus")}</NavbarLink>
            <NavbarLink to="/companies" className="pointer-events-auto">{t("navbar.companies")}</NavbarLink>
            <NavbarLink to="/projects" className="pointer-events-auto">{t("navbar.projects")}</NavbarLink>
            <NavbarLink to="/investment" className="pointer-events-auto">{t("navbar.investment")}</NavbarLink>
            <NavbarLink to="/actualities" className="pointer-events-auto">{t("navbar.actualities")}</NavbarLink>
            <NavbarLink
              className="hidden lg:block pointer-events-auto"
              onClick={() =>
                window.scrollTo({
                  top: document.documentElement.scrollHeight,
                  behavior: "smooth",
                })
              }
              to="#"
            >
              {t("navbar.contact")}
            </NavbarLink>
          </div>

          {/* Right Section: Language & Mobile Menu Button */}
          <div className="flex justify-end items-center gap-4 pointer-events-none">
            <div className="pointer-events-auto">
              <LanguageDropdown />
            </div>
            <div
              onClick={toggleMenu}
              className="cursor-pointer lg:hidden text-vinefin-700 hover:text-vinefin-900 transition pointer-events-auto"
            >
              <Icon path={open ? mdiClose : mdiMenu} size={1.5} />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          open ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-4 pt-2 pb-6 space-y-2 bg-white shadow-lg rounded-b-2xl mx-4 flex flex-col">
          <NavbarLink to="/" onClick={() => setOpen(false)}>
            {t("navbar.aboutus")}
          </NavbarLink>
          <NavbarLink to="/companies" onClick={() => setOpen(false)}>
            {t("navbar.companies")}
          </NavbarLink>
          <NavbarLink to="/projects" onClick={() => setOpen(false)}>
            {t("navbar.projects")}
          </NavbarLink>
          <NavbarLink to="/investment" onClick={() => setOpen(false)}>
            {t("navbar.investment")}
          </NavbarLink>
          <NavbarLink to="/actualities" onClick={() => setOpen(false)}>
            {t("navbar.actualities")}
          </NavbarLink>
          <NavbarLink
            onClick={() => {
              window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: "smooth",
              });
              setOpen(false);
            }}
            to="#"
          >
            {t("navbar.contact")}
          </NavbarLink>
        </div>
      </div>
    </nav>
  );
}
